import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('product-variant');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    changeStockAmount(ctx, { id, by }) {
        return axios.$post(
            `/admin/product-variants/${id}/change-stock-amount`,
            {
                by
            }
        );
    }
};
